module.exports = __webpack_public_path__ + "static/media/13.53836550.jpg";